import { gql } from "@apollo/client";

export const ACTUALIZAR_PRECIO_MINUTA = gql`
mutation ActualizarPrecioMinuta (
    $idEvaluacion: Int!,
    $idMinuta: Int!,
    $precio: Decimal!
){
    actualizarPrecioMinuta (
        idEvaluacion: $idEvaluacion,
        idMinuta: $idMinuta,
        precio: $precio
    ) {
      success,
      valorEsperado,
      error
    }
}
`;